// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LinkPresentationProps, StyledTypography } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color, mergeWithCss } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export const textStyles: TypographyPresentationProps = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.regular,
    color: "text",
};

export const headerText: TypographyPresentationProps = {
    variant: "h5"
};

export const linkStyles: LinkPresentationProps = {
    typographyProps: textStyles,
    css: css`
        ${StyledTypography} {
            color: ${color("text.main")};

            b {
                font-weight: ${fontConfig.weight.regular};
            }
        }
    `,
};

export const itemText: TypographyPresentationProps = {
    ...textStyles,
    css: css`
        margin-bottom: 10px;
        span > b {
            font-weight: ${fontConfig.weight.regular};
        }
    `,
};

export const titleText: TypographyPresentationProps = {
    ...textStyles,
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 10px;
    `,
};

export const focusedItemText: TypographyPresentationProps = {
    ...mergeWithCss(textStyles, {
        css: css`
            background: ${color("common.ui3")};
            margin-bottom: 12px;
        `,
    }),
};
